import React from 'react'
import { Link } from 'react-router-dom'
import Bread_1 from '../../../assets/images/home_page_4/breadcrumb/01.png'
import Bread_2 from '../../../assets/images/home_page_4/breadcrumb/02.png'
import Bread_3 from '../../../assets/images/home_page_4/breadcrumb/03.png'

const BreadCrumbImage = () => {
    return (
        <>
            <section className="breadcrumb-image-main-block">
                <div className="container">
                    <div className="breadcrumb-image-block">
                        <div className="row">
                            <div className="col-xl-4 col-lg-6">
                                <div className="advertise-block">
                                    <h6 className="advertise-sub-heading">Weekend Discount</h6>
                                    <h2 className="advertise-heading">
                                        Olympus Mark II Mirrorless Camera
                                    </h2>
                                    <p>Mirrorless Camera with 4K Video</p>
                                    <Link title="" className="btn btn-primary">
                                        Shop Now
                                        <i className="flaticon-right-arrows" />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-xl-8 col-lg-6">
                                <ul className="discount-img">
                                    <li className="image-one">
                                        <img
                                            src={Bread_1}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </li>
                                    <li className="image-two">
                                        <img
                                            src={Bread_2}
                                            className="img-fluid"

                                            alt=""
                                        />
                                    </li>
                                    <li className="image-three">
                                        <img
                                            src={Bread_3}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="breadcrumb-image-bg" />
                    </div>
                </div>
            </section>

        </>
    )
}

export default BreadCrumbImage
